import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=c05f6bee&scoped=true"
import script from "./StudentEdit.vue?vue&type=script&lang=ts"
export * from "./StudentEdit.vue?vue&type=script&lang=ts"
import style0 from "./StudentEdit.vue?vue&type=style&index=0&id=c05f6bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05f6bee",
  null
  
)

export default component.exports